import { SetStateAction } from 'react'
import { cargoTypes, SLOT_ROUTE } from '../../../utils/constants'
import classes from './CargoSelector.module.sass'
import SelectorItem from './components/selectorItem/SelectorItem'
import { useCargoSelector } from './hooks/useCargoSelector'
import { TypesObject } from '../../../types/interfaces'
import { useLocation } from 'react-router-dom'
import { CargoTypes } from '../../../types/enums'

type Props = {
  topData: TypesObject
  setTopData: React.Dispatch<SetStateAction<TypesObject>>
}

export const CargoSelector = ({ setTopData, topData }: Props) => {
  const { toggleType, type } = useCargoSelector(setTopData, topData)
  const location = useLocation()

  return (
    <div className={classes.Container}>
      <>
        <div className={classes.Label}>Параметры груза</div>

        <div className={classes.SelectorContainer}>
          {cargoTypes
            .filter((el) =>
              location.pathname.includes(SLOT_ROUTE)
                ? el.id !== CargoTypes.WOOD && el.id !== CargoTypes.BULK
                : el,
            )
            .map((el) => (
              <SelectorItem key={el.id} el={el} onClick={toggleType} value={type} />
            ))}
        </div>
      </>
    </div>
  )
}
